import noImageAvailable from './assets/images/no_image_available.jpg';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const SSE_BASE_URL =
  import.meta.env.VITE_SSE_BASE_URL ||
  'https://stg-cs-stream-api.samsunghrm.com/api/sse';
export const NO_IMAGE = noImageAvailable;
export const MONITOR_GUIDEBASEURL =
  'https://resources.samsunghrm.com/DESCRIPTION/Monitoring_guide';
export const GUIDEBASEURL =
  'https://resources.samsunghrm.com/DESCRIPTION/Guide_';

export const VITE_AUTH_USER_NAME = import.meta.env.VITE_AUTH_USER_NAME;
export const VITE_AUTH_ACCESS_TOKEN = import.meta.env.VITE_AUTH_ACCESS_TOKEN;

// Offline Monitoring Flag
export const ALLOW_OFFLINE_MONITORING = import.meta.env.VITE_ALLOW_OFFLINE_MONITORING === 'true';

// Force Control Flag (for local testing - skips waiting for device state change)
export const SKIP_STATE_CHANGE_CHECK_FOR_FORCE_CONTROL = import.meta.env.VITE_SKIP_STATE_CHANGE_CHECK_FOR_FORCE_CONTROL === 'true';

// Chatbot Configuration (secure - uses import.meta.env, not inlined process.env)
export const VITE_CHATBOT_API_URL = import.meta.env.VITE_CHATBOT_API_URL || '';
export const VITE_ENABLE_CHATBOT = import.meta.env.VITE_ENABLE_CHATBOT === 'true';
